import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import img1 from "../assets/images/noimage.jpg";
import { MyApi } from "../MyApi";
import useSEO from "../hooks/useSEO"; // adjust path if needed

export default function ToursList() {
  const { categorySlug } = useParams();
  const [category, setCategory] = useState(null);
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCategoryTours = async () => {
      try {
        const res = await axios.get(
          `${MyApi.BASE_URL}tours-list/${categorySlug}`,
          { headers: { Authorization: MyApi.SECRET_KEY } }
        );

        if (res.data.status) {
          setCategory(res.data.category);
          setTours(res.data.data || []);
        } else {
          setError(res.data.message || "No data found");
        }
      } catch (err) {
        console.error("API error:", err);
        setError("API request failed");
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryTours();
  }, [categorySlug]);

  // ✅ SEO META TAGS (Dynamic per category)
  useSEO({
    title: category?.meta_title
      || `${category?.categoryheading || "Taxi Service Varanasi | Cab Booking, Airport Pickup & Outstation Taxi"} | Taxi Service in Varanasi`,
    description: category?.meta_description
      || `Explore the best ${category?.categoryheading || "Varanasi"} Book reliable taxi service in Varanasi for local sightseeing, airport pickup & outstation trips to Ayodhya, Prayagraj & Bodhgaya. 24/7 support, sanitized cars & professional drivers.`,
    keywords: category?.meta_tags
      || "Taxi Service Varanasi, Cab booking Varanasi, Airport taxi Varanasi, Outstation taxi Varanasi, Varanasi sightseeing taxi, Cab hire Varanasi",
    canonical: window.location.href,
    ogImage: tours?.[0]?.image_url || "",
  });

  if (loading) return <p className="text-center py-5">Loading tours...</p>;
  if (error) return <p className="text-center py-5">{error}</p>;

  return (
    <div className="bg_image experts">
     <div className="BreadcrumbStyle mb-5">
        <Container>
          <h1>{category?.categoryheading || "Tour Packages"}</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
             {category?.categoryheading || "Tour Packages"}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>
      <Container>
        <div className="servi_bx">

          <Row>
            {tours.length > 0 ? (
              tours.map((tour) => (
                <Col md="4" key={tour.id}>
                  <div className="custom-figure mb-4">
                    <Link to={`/${category.categoryurl}/${tour.producturl}`}>
                      <img
                        src={tour.image_url || img1}
                        alt={tour.productname}
                        className="img-fluid"
                      />
                    </Link>

                    <Link
                      to={`/${category.categoryurl}/${tour.producturl}`}
                      className="figcaption"
                    >
                      <h3>{tour.productname}</h3> 
                      <p>{tour.productheading || ""}</p> 
                    </Link>
                        <a
      href={`https://wa.me/919569234541?text=${encodeURIComponent(
        `Hi, I want details about ${tour.productname}.
        
Product Link: ${window.location.origin}/${category.categoryurl}/${tour.producturl}`
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-danger mt-2 position-absolute top-0   z-3"
      style={{right:10}}
    >
      Book Now
    </a>
                  </div>
                </Col>
              ))
            ) : (
              <Col>
                <p className="text-center">No tours found in this category</p>
              </Col>
            )}
          </Row>
        </div>
      </Container>
    </div>
  );
}
